import React, { useEffect } from "react";
import LoginForm from "../component/login/LoginForm";
import { useCurrentUser } from "../component/authentication/useCurrentUser";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const authSwapVariants = {
  initial: { opacity: 0, x: -72, scale: 0.98 },
  animate: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: { duration: 0.38, ease: [0.22, 1, 0.36, 1] },
  },
  exit: {
    opacity: 0,
    x: -72,
    scale: 0.98,
    transition: { duration: 0.28, ease: [0.4, 0, 1, 1] },
  },
};

const Login = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useCurrentUser();

  useEffect(() => {
    if (isAuthenticated) return navigate("/dashboard");
  }, [navigate, isAuthenticated]);
  return (
    <motion.div
      variants={authSwapVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className="flex min-h-screen items-center justify-center bg-gray-100 px-4 pb-10 pt-28 dark:bg-bodyColor"
    >
      <LoginForm />
    </motion.div>
  );
};

export default Login;
